<template>
    <div v-if="event.provider ? event.provider.includes('survey') : false">
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="showEdit = !showEdit">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :visible.sync="showEdit"
            :close-on-click-modal="false"
            :before-close="closePopup">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <div class="flex-cont">
                <div class="date inl">
                    {{ qDate }}
                </div>
                <template>
                    <ol class="multi-question-edit" type="a">
                        <li v-for="(subResponse, sRIndex) in updateResponse"
                            :key="sRIndex" class="sub-quest-cont">
                            <div class="sub-question">
                                <b>{{ subResponse.title }}</b> ({{subResponse.question}})
                            </div>
                            <div v-if="subResponse.type === 'select'" class="select-sub-quest-cont sub-quest">
                                <el-radio-button 
                                    v-for="(option, index) in [...questionOptions[sRIndex], ...subResponse.prevOtherOptions]"
                                    @click.native.prevent="clickItem(option.label, sRIndex, subResponse.type)"
                                    :key="'pre' + index"
                                    :label="option.label"
                                    :class="[{ selected: subResponse.answer != null && !!subResponse.answer.length && subResponse.answer.includes(option.label) }]">
                                </el-radio-button>
                                <div 
                                    class="inl other-added-option-container"
                                    v-if="subResponse.otherEnabled && subResponse.otherOptionList && subResponse.otherOptionList.length > 0">
                                    <span
                                        :class="['other-added-option',{ 'otherSelectedOption': subResponse.answer != null && !!subResponse.answer.length && subResponse.answer.includes(option) }]" 
                                        v-for="(option, index) in subResponse.otherOptionList"
                                        @click.self="clickItem(option, sRIndex, subResponse.type)"
                                        :key="'pre' + index">
                                            {{ option }}
                                    </span>
                                </div>
                                <el-button
                                    class="inl add-button-container"
                                    v-if="subResponse.otherEnabled && !subResponse.showAddInput"
                                    @click="addInputIconClicked(sRIndex)">
                                        <AddIcon class="add-button"></AddIcon>
                                </el-button>
                                <span v-if="subResponse.answer && subResponse.answer.length < 1" class="no-answer">
                                    Not Answered
                                </span>
                                <div class="other-input-container">
                                    <el-input 
                                        class="other-input-field"
                                        v-if="subResponse.otherEnabled && subResponse.showAddInput"
                                        v-model="subResponse.otherOption"
                                        placeholder="Add other option" 
                                        @change="addOtherInput(sRIndex)">
                                    </el-input>
                                </div>
                                <div class="remove-mand-cont" v-if="subResponse.showRmvResp || checkIfMndtSubQuest[sRIndex]">
                                    <div class="remove-response" v-if="subResponse.showRmvResp">
                                        <RemoveResponseIcon></RemoveResponseIcon>
                                        <span @click="removeResponse(sRIndex, subResponse.type)">Remove Response</span>
                                    </div>
                                    <div class="mandatory-quest" v-if="checkIfMndtSubQuest[sRIndex]"> 
                                        <span>
                                            * Mandatory
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="subResponse.type === 'date'" class="date-sub-quest-cont sub-quest">
                                <el-date-picker
                                    v-model="subResponse.answer"
                                    @change="onResponseChange(sRIndex, subResponse.type)"
                                    :picker-options="pickerOptions(subResponse.disalFutDate)"
                                    :clearable="!checkIfMndtSubQuest[sRIndex]"
                                    :type="subResponse.dateConfig.type"
                                    :format="subResponse.dateConfig.format"
                                    :placeholder="`Pick a ${subResponse.dateConfig.type}`">
                                </el-date-picker>
                                <div class="remove-mand-cont" v-if="subResponse.showRmvResp || checkIfMndtSubQuest[sRIndex]">
                                    <div class="remove-response" v-if="subResponse.showRmvResp">
                                        <RemoveResponseIcon></RemoveResponseIcon>
                                        <span @click="removeResponse(sRIndex, subResponse.type)">Remove Response</span>
                                    </div>
                                    <div class="mandatory-quest" v-if="checkIfMndtSubQuest[sRIndex]"> 
                                        <span>
                                            * Mandatory
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="subResponse.type === 'scroller'" class="scroller-sub-quest-cont sub-quest">
                                <el-radio-group v-model="subResponse.answer" @click.native="onResponseChange(sRIndex, subResponse.type)">
                                    <el-radio-button 
                                        @click.native.prevent="clickItem(option.value, sRIndex, subResponse.type)"
                                        v-for="option in questionOptions[sRIndex]" 
                                        :key="option.value"
                                        :label="option.label"
                                        :class="[{ selected: subResponse.answer != null && subResponse.answer && String(parseInt(subResponse.answer)-1) === option.value }]">
                                    </el-radio-button>
                                </el-radio-group>
                                <span v-if="(subResponse.answer == undefined || subResponse.answer == null || subResponse.answer == '')" class="no-answer">
                                    Not Answered
                                </span>
                                <div class="remove-mand-cont" v-if="subResponse.showRmvResp || checkIfMndtSubQuest[sRIndex]">
                                    <div class="remove-response" v-if="subResponse.showRmvResp">
                                        <RemoveResponseIcon></RemoveResponseIcon>
                                        <span @click="removeResponse(sRIndex, subResponse.type)">Remove Response</span>
                                    </div>
                                    <div class="mandatory-quest" v-if="checkIfMndtSubQuest[sRIndex]"> 
                                        <span>
                                            * Mandatory
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="subResponse.type === 'text'" class="text-sub-quest-cont sub-quest">
                                <el-input
                                    v-model="subResponse.answer"
                                    @change="onResponseChange(sRIndex, subResponse.type)">
                                </el-input>
                                <span v-if="subResponse.answer == undefined || subResponse.answer == null || subResponse.answer == ''" class="no-answer">
                                    Not Answered
                                </span>
                                <div class="remove-mand-cont" v-if="subResponse.showRmvResp || checkIfMndtSubQuest[sRIndex]">
                                    <div class="remove-response" v-if="subResponse.showRmvResp">
                                        <RemoveResponseIcon></RemoveResponseIcon>
                                        <span @click="removeResponse(sRIndex, subResponse.type)">Remove Response</span>
                                    </div>
                                    <div class="mandatory-quest" v-if="checkIfMndtSubQuest[sRIndex]"> 
                                        <span>
                                            * Mandatory
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="unit-sub-quest-cont sub-quest" v-if="subResponse.type === 'unit'">
                                <div class="input-num inl-fl">
                                    <el-input-number
                                        size="small"
                                        :controls="false"
                                        placeholder="Enter Value"
                                        v-model="subResponse.answer.value"
                                        @change="onResponseChange(sRIndex, subResponse.type, true)">>
                                    </el-input-number>
                                    <span v-show="showUpdateResponseErrorMsg(sRIndex)" class="error-message">
                                        Enter value to continue
                                    </span>
                                </div>
                                <div class="input-sel inl-fl">
                                    <el-select v-model="subResponse.answer.unit" size="small" placeholder="Select Unit" @change="onResponseChange(sRIndex, subResponse.type, false)">>
                                        <el-option v-for="option in questionOptions[sRIndex]"
                                            :key="option.value"
                                            :label="option.display_text"
                                            :value="option.value">
                                        </el-option>
                                    </el-select>
                                    <span v-show="showUpdateUnitErrorMsg(sRIndex)" class="error-message">
                                        Select unit to continue
                                    </span>
                                </div>
                                <span v-if="((subResponse.answer.value == undefined || subResponse.answer.value == null || subResponse.answer.value == '') && (subResponse.answer.unit == undefined || subResponse.answer.unit == null || subResponse.answer.unit == ''))" class="no-answer">
                                    Not Answered
                                </span>
                                <div class="remove-mand-cont" v-if="subResponse.showRmvResp || checkIfMndtSubQuest[sRIndex]">
                                    <div class="remove-response" v-if="subResponse.showRmvResp">
                                        <RemoveResponseIcon></RemoveResponseIcon>
                                        <span @click="removeResponse(sRIndex, subResponse.type)">Remove Response</span>
                                    </div>
                                    <div class="mandatory-quest" v-if="checkIfMndtSubQuest[sRIndex]"> 
                                        <span>
                                            * Mandatory
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ol>
                </template>
            </div>
            <div class="footer">
                <el-button type="text" size="small" class="cancel-button" @click="closePopup()">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        :disabled="!checkIfSaveEligible"
                        @click="updateQuestion"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionEdit from './'
import Icons from '../analysis/response/icon'
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'edit-multi-question',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            questionOptions: this.getQuestionOptions(),
            checkIfMndtSubQuest: this.checkIfMandatorySubQuestion()
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.updateResponse = this.getQuestionResponse()
            this.questionOptions = this.getQuestionOptions()
            this.checkIfMndtSubQuest = this.checkIfMandatorySubQuestion()
        },
        removeResponse(rindx, sQType) {
            switch(sQType) {
                case 'select': {
                    this.updateResponse[rindx].answer = []
                    this.updateResponse[rindx].showRmvResp = false
                    this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                    break
                } 
                case 'date': {
                    this.updateResponse[rindx].answer = ''
                    this.updateResponse[rindx].showRmvResp = false
                    this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                    break
                } 
                case 'scroller': {
                    this.updateResponse[rindx].answer = null
                    this.updateResponse[rindx].showRmvResp = false
                    this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                    break
                }
                case 'text': {
                    this.updateResponse[rindx].answer = ''
                    this.updateResponse[rindx].showRmvResp = false
                    this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                    break
                } 
                case 'unit': {
                    this.updateResponse[rindx].answer.value = ''
                    this.updateResponse[rindx].answer.unit = ''
                    this.updateResponse[rindx].showRmvResp = false
                    this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                    break
                } 
            }
            this.updateSaveEnabled()
        },
        addInputIconClicked(rindx) {
            this.updateResponse[rindx].showAddInput = true
        },
        addOtherInput(rindx) {
            if(this.updateResponse[rindx].otherOption && this.updateResponse[rindx].otherOption.trim() !== "") {
                this.updateResponse[rindx].otherOptionList.push(this.updateResponse[rindx].otherOption)
                this.updateResponse[rindx].answer.push(this.updateResponse[rindx].otherOption)
                this.updateResponse[rindx].otherOption = ""
            }
            this.updateResponse[rindx].subQustEnblSave = true
            this.updateResponse[rindx].showAddInput = false
        },
        onResponseChange(rindx, sQType, unitValChanged = false) {
            switch(sQType) {
                case 'select': {
                    if(this.updateResponse[rindx].answer.length > 0) {
                        this.updateResponse[rindx].subQustEnblSave = true
                        this.updateResponse[rindx].showRmvResp = this.checkIfMndtSubQuest[rindx] ? false : true
                    } else {
                        this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                        this.updateResponse[rindx].showRmvResp = false
                    }
                    break
                } 
                case 'date': {
                    if(this.updateResponse[rindx] && this.updateResponse[rindx].answer &&
                        (this.updateResponse[rindx].answer != null || this.updateResponse[rindx].answer != "")) {
                            this.updateResponse[rindx].subQustEnblSave = true
                            this.updateResponse[rindx].showRmvResp = this.checkIfMndtSubQuest[rindx] ? false : true
                    } else {
                        this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                        this.updateResponse[rindx].showRmvResp = false
                    }
                    break
                } 
                case 'scroller': {
                    this.updateResponse[rindx].subQustEnblSave = true
                    this.updateResponse[rindx].showRmvResp = !this.checkIfMndtSubQuest[rindx] && this.updateResponse[rindx].answer !== null ? true : false
                    break
                }
                case 'text': {
                    if(this.updateResponse[rindx] && this.updateResponse[rindx].answer &&
                        (this.updateResponse[rindx].answer != null || this.updateResponse[rindx].answer != "")) {
                            this.updateResponse[rindx].subQustEnblSave = true
                            this.updateResponse[rindx].showRmvResp = this.checkIfMndtSubQuest[rindx] ? false : true
                    } else {
                        this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
                        this.updateResponse[rindx].showRmvResp = false
                    }
                    break
                } 
                case 'unit': {
                    if(unitValChanged) {
                        if(this.updateResponse[rindx] && 
                            this.updateResponse[rindx].answer && 
                            this.updateResponse[rindx].answer.value && 
                            (this.updateResponse[rindx].answer.value != null || this.updateResponse[rindx].answer.value != "")) {
                                this.updateResponse[rindx].showRmvResp = this.checkIfMndtSubQuest[rindx] ? false : true
                        } else {
                            this.updateResponse[rindx].showRmvResp = false
                        }

                        this.checkEnableSaveOnUnitResponseChange(rindx)
                    } else {
                        if(this.updateResponse[rindx] && 
                            this.updateResponse[rindx].answer && 
                            this.updateResponse[rindx].answer.unit && 
                            (this.updateResponse[rindx].answer.unit != null || this.updateResponse[rindx].answer.unit != "")) {
                                this.updateResponse[rindx].showRmvResp = this.checkIfMndtSubQuest[rindx] ? false : true
                        } else {
                            this.updateResponse[rindx].showRmvResp = false
                        }

                        this.checkEnableSaveOnUnitResponseChange(rindx)
                    }
                    break
                } 
            }
            this.updateSaveEnabled()
        },

        updateSaveEnabled() {
            this.updateResponse.forEach((subQuest,indx) => {
                switch(subQuest.type) {
                    case 'select': {
                        if(subQuest.answer.length > 0) {
                            subQuest.subQustEnblSave = true
                        } else {
                            subQuest.subQustEnblSave = this.checkIfMndtSubQuest[indx] ? false : true
                        }
                        break
                    } 
                    case 'date': {
                        if(subQuest.answer == '' || subQuest.answer == null || subQuest.answer == undefined) {
                            subQuest.subQustEnblSave = this.checkIfMndtSubQuest[indx] ? false : true
                        } else {
                            subQuest.subQustEnblSave = true
                        }
                        break
                    } 
                    case 'scroller': {
                        if(subQuest.answer == '' || subQuest.answer == null || subQuest.answer == undefined) {
                            subQuest.subQustEnblSave = this.checkIfMndtSubQuest[indx] ? false : true
                        } else {
                            subQuest.subQustEnblSave = true
                        }
                        break
                    }
                    case 'text': {
                        if(subQuest.answer == '' || subQuest.answer == null || subQuest.answer == undefined) {
                            subQuest.subQustEnblSave = this.checkIfMndtSubQuest[indx] ? false : true
                        } else {
                            subQuest.subQustEnblSave = true
                        }
                        break
                    } 
                    case 'unit': {
                        if(subQuest.answer && subQuest.answer.value && subQuest.answer.unit && (subQuest.answer.value != null || subQuest.answer.value == '') && (subQuest.answer.unit != null || subQuest.answer.unit == '')) {
                            subQuest.subQustEnblSave = true
                        } else {
                            subQuest.subQustEnblSave = this.checkIfMndtSubQuest[indx] ? false : true
                        }
                        break
                    } 
                }
            })
        },

        checkEnableSaveOnUnitResponseChange(rindx) {
            if(this.updateResponse[rindx] && 
                this.updateResponse[rindx].answer && 
                this.updateResponse[rindx].answer.value && 
                this.updateResponse[rindx] && 
                this.updateResponse[rindx].answer && 
                this.updateResponse[rindx].answer.unit && 
                (this.updateResponse[rindx].answer.value != null || this.updateResponse[rindx].answer.value != "") && 
                (this.updateResponse[rindx].answer.unit != null || this.updateResponse[rindx].answer.unit != "")) {
                    this.updateResponse[rindx].subQustEnblSave = true
            } else this.updateResponse[rindx].subQustEnblSave = this.checkIfMndtSubQuest[rindx] ? false : true
        },
        clickItem(e, rindx, sqType) {
            switch(sqType) {
                case 'select': {
                    if(this.updateResponse[rindx].answer && !this.updateResponse[rindx].answer.length) {
                        this.updateResponse[rindx].answer.push(e)
                    } else {
                        if(this.updateResponse[rindx].singleSelect) {
                            if(this.updateResponse[rindx].answer.includes(e)) {
                                this.updateResponse[rindx].answer = []
                            } else {
                                this.updateResponse[rindx].answer = []
                                this.updateResponse[rindx].answer.push(e)
                            }
                        }
                        else {
                            if(this.updateResponse[rindx].answer.includes(e)) {
                                if(!this.checkIfMndtSubQuest[rindx]  || this.updateResponse[rindx].answer.length > 1) {
                                    const foundIndex = this.updateResponse[rindx].answer.indexOf(e)
                                    if (foundIndex > -1) {
                                        this.updateResponse[rindx].answer.splice(foundIndex, 1)
                                    }
                                }
                            } else {
                                this.updateResponse[rindx].answer.push(e)
                            }
                        }
                    }

                    this.onResponseChange(rindx,sqType)
                    
                    break
                } 
                case 'scroller': {
                    let selectedValue = String((parseInt(e) + 1))
                    if(selectedValue === this.updateResponse[rindx].answer && !this.checkIfMndtSubQuest[rindx]) this.updateResponse[rindx].answer = null
                    else this.updateResponse[rindx].answer = selectedValue
                    
                    break
                }
            }
        },
        checkIfAnswered(sRId) {
            return this.oresponse && this.oresponse.some((answer) => 
                answer.id === sRId && Array.isArray(answer.answer) && answer.answer.length > 0
            )
        },
        checkIfMandatorySubQuestion() {
            return this.question.questions.map((subQuestion) => {
                return this.checkIfMandatoryVal(subQuestion)
            })
        },
        checkIfMandatoryVal(subQuest) {
            if(Array.isArray(subQuest.validations) && subQuest.validations.length > 0) {
                for(let obj of subQuest.validations) {
                    if(obj && "mandatory" in obj && JSON.parse(JSON.stringify(obj)).mandatory)
                        return true
                    else if(obj && "mandatory" in obj && !JSON.parse(JSON.stringify(obj)).mandatory)
                        return false
                    else continue
                }
            } else
                return false
        },
        checkIfDisalFutDates(subQuest) {
            if(Array.isArray(subQuest.validations) && subQuest.validations.length > 0) {
                return subQuest.validations.some((obj) => 
                    obj && Object.keys(obj).includes('before') && JSON.parse(JSON.stringify(obj)).before == 'tomorrow' && 
                    Object.keys(obj).includes('type') && JSON.parse(JSON.stringify(obj)).type == 'range'
                )
            } 
            else
                return false
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            console.log('Index - ',this.updateIndex)
            console.log(update)
            //return
            this.savingEdit = true
            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false,
                    this.showEdit = false,
                    this.updateResponse = this.getQuestionResponse(),
                    this.questionOptions = this.getQuestionOptions()
                    this.checkIfMndtSubQuest = this.checkIfMandatorySubQuestion()
                })
        },
        getQuestionOptions() {
            return this.question.questions.map((subQuestion) => {
                switch (subQuestion.type) {
                    case 'select':
                        return subQuestion.options.map((elem) => ({
                            value: elem.value,
                            label: elem.value
                        }))
                    case 'scroller':
                        return  Object.entries(subQuestion.label).map(([key, value]) => ({
                            value: key,
                            label: value ? value : String((parseInt(key) + 1))
                        }))
                    case 'unit': 
                        return subQuestion.options.map(uOpt => uOpt)
                    default:
                        return []
                }
            })
        },
        getQuestionResponse() {
            return this.question.questions.map((subQuestion,indx) => {
                    const { question, title, id, type } = subQuestion
                    let answer = this.oresponse ? this.oresponse.find((answer) => answer.id === id) : null
                    if(answer && answer.answer) {
                        let copyAns = JSON.parse(JSON.stringify(answer.answer))

                        if(subQuestion.type === 'select') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                otherEnabled: subQuestion.other ? true : false,
                                singleSelect: subQuestion.single ? true : false,
                                otherOptionList: [],
                                prevOtherOptions: this.separateOtherOptions(copyAns,subQuestion.option).tempPrevOtherOptions,
                                showAddInput: false,
                                otherOption: "",
                                answer: this.separateOtherOptions(copyAns,subQuestion.option).tempNormalOptionAnswer,
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        } else if(subQuestion.type === 'date') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                dateConfig: subQuestion.prompt.includes('date') ? 
                                    ({
                                        type: 'date',
                                        format: 'MMM d, yyyy'
                                    }) : 
                                    ({
                                        type: 'month',
                                        format: 'MMM, yyyy'
                                    }),
                                answer: copyAns[0] ? new Date(copyAns[0].year, copyAns[0].month - 1, copyAns[0].date || 1) : '',
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id),
                                disalFutDate: this.checkIfDisalFutDates(subQuestion)
                            }
                        } else if(subQuestion.type === 'scroller') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                answer: copyAns[0] && copyAns[0].value ? String(parseInt(copyAns[0].value) + 1) : null,
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        } else if(subQuestion.type === 'text') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                answer: copyAns[0] && copyAns[0].answer ? copyAns[0].answer : '',
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        } else {
                            return {
                                question,
                                title,
                                id,
                                type,
                                answer: {
                                    value: copyAns[0] && copyAns[0].answer ? copyAns[0].answer : '',
                                    unit: copyAns[0] && copyAns[0].value ? copyAns[0].value : ''
                                },
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        }
                    }
                        
                    else {
                        if(subQuestion.type === 'select') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                otherEnabled: subQuestion.other ? true : false,
                                singleSelect: subQuestion.single ? true : false,
                                otherOptionList: [],
                                prevOtherOptions: [],
                                showAddInput: false,
                                otherOption: "",
                                answer: [],
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        } else if(subQuestion.type === 'date') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                dateConfig: subQuestion.prompt.includes('date') ? 
                                    ({
                                        type: 'date',
                                        format: 'MMM d, yyyy'
                                    }) : 
                                    ({
                                        type: 'month',
                                        format: 'MMM, yyyy'
                                    }),
                                answer: '',
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id),
                                disalFutDate: this.checkIfDisalFutDates(subQuestion)
                            }  
                        } else if(subQuestion.type === 'scroller') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                answer: null,
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        } else if(subQuestion.type === 'text') {
                            return {
                                question,
                                title,
                                id,
                                type,
                                answer: '',
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        } else {
                            return {
                                question,
                                title,
                                id,
                                type,
                                answer: {
                                    value: '',
                                    unit: ''
                                },
                                subQustEnblSave: false,
                                showRmvResp: !this.checkIfMandatoryVal(subQuestion) && this.checkIfAnswered(subQuestion.id)
                            }
                        }
                    }
                })
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: []
            }

            update.answer = this.updateResponse.map((subResp) => {
                if(subResp.type == 'select') {
                    if(subResp.answer.length > 0) {
                        let tempAnswer

                        tempAnswer = subResp.answer.map((selVal) => {
                            if(subResp.otherOptionList && subResp.otherOptionList.includes(selVal)) {
                                return this.createOtherOptionAddedObject(selVal)
                            }
                            else {
                                return this.getOptionAddedObject(selVal, subResp.id)
                            }
                        })

                        return {
                            answer: tempAnswer,
                            id: subResp.id
                        }
                    } else {
                        return {
                            answer: [],
                            id: subResp.id
                        }
                    }

                } else if(subResp.type === 'date') {
                    if(subResp.answer instanceof Date) {
                        let tempAnswer = {
                            month: subResp.answer.getMonth() + 1,
                            year: subResp.answer.getFullYear()
                        }
                        if(subResp.type === 'date')
                            tempAnswer.date = subResp.answer.getDate()
                        if(this.questionResponseId(subResp.type, subResp.id))
                            tempAnswer.id = this.questionResponseId(subResp.type, subResp.id)
                        else
                            tempAnswer.id = uuidv4()

                        return {
                            answer: [tempAnswer],
                            id: subResp.id
                        }
                    } else {
                        return {
                            answer: null,
                            id: subResp.id
                        }
                    }

                } else if(subResp.type === 'scroller') {
                    if(subResp.answer) {
                        const tempSubQuesId = subResp.id
                        let obj = this
                        let allUpdateOptions = this.findUpdateOptionsObject(tempSubQuesId)
                        let updateOption = JSON.parse(JSON.stringify(allUpdateOptions.find((opt) => opt.value == String(parseInt(subResp.answer) - 1))))
                        return {
                            answer: [{...updateOption}],
                            id: subResp.id
                        }
                    } else {
                        return {
                            answer: null,
                            id: subResp.id
                        }
                    }
                } else if(subResp.type === 'text') {
                    return {
                        answer: [{
                            answer: subResp.answer ? subResp.answer : '',
                            id: this.questionResponseId(subResp.type, subResp.id) ? this.questionResponseId(subResp.type, subResp.id) : uuidv4()
                        }],
                        id: subResp.id
                    }
                } else {
                    if(subResp.answer.value && subResp.answer.unit) {
                        const tempSubQuesId = subResp.id
                        let obj = this
                        let updateUnitOption = JSON.parse(JSON.stringify(obj.findUpdateOptionsObject(tempSubQuesId).find((unitOpt) => unitOpt.value == subResp.answer.unit)))
                        return {
                            answer: [{
                                value: updateUnitOption.value,
                                display_text: updateUnitOption.display_text,
                                answer: subResp.answer.value,
                                id: updateUnitOption.id
                            }],
                            id: subResp.id
                        }
                    } else {
                        return {
                            answer: [],
                            id: subResp.id
                        }
                    }
                }
            })

            return update
        },
        getOptionAddedObject(optVal, subQId) {
            let obj = this

            let answer = this.oresponse ? this.oresponse.find((answer) => answer.id === subQId) : null
            
            if(answer && answer.answer) {
                let tempVar, optionObject

                optionObject = answer.answer.find((optValu) => optValu.value === optVal)

                if(optionObject != undefined || optionObject != null) {
                    tempVar = JSON.parse(JSON.stringify(answer.answer.find(({value}) => optVal == value)))
                } else {
                    tempVar = JSON.parse(JSON.stringify(obj.findUpdateOptionsObject(subQId).find(({value}) => value == optVal)))
                }

                return tempVar
            }
            else return {}
        },
        createOtherOptionAddedObject(otherValue) {
            return {
                description: otherValue,
                value: otherValue,
                id: uuidv4()
            }
        },
        findUpdateOptionsObject(subRespId) {
            let obj = this
            return JSON.parse(JSON.stringify(obj.question.questions.find((subQuest) => subQuest.id === subRespId).options))
        },
        showUpdateResponseErrorMsg: function(indx) {
            if(this.updateResponse[indx] && 
                this.updateResponse[indx].answer && 
                this.updateResponse[indx].answer.value && 
                (this.updateResponse[indx].answer.value != null || this.updateResponse[indx].answer.value != "")) {
                    return false
            } else return true
        },
        showUpdateUnitErrorMsg: function(indx) {
            if(this.updateResponse[indx] && 
                this.updateResponse[indx].answer && 
                this.updateResponse[indx].answer.unit && 
                (this.updateResponse[indx].answer.unit != null || this.updateResponse[indx].answer.unit != "")) {
                    return false
            } else return true
        },
        separateOtherOptions(allAns, subQuestOptions) {
            let tempNormalOptionAnswer = [], tempPrevOtherOptions = []

            allAns.forEach((answer) => {
                if(!subQuestOptions.includes(answer.value)) {
                    tempPrevOtherOptions.push({
                        value: answer.value,
                        label: answer.value
                    })
                }
                tempNormalOptionAnswer.push(answer.value)
            })
            
            return {
                tempNormalOptionAnswer, tempPrevOtherOptions
            }
        },
        questionResponseId(subQType, subQId) {
            switch(subQType) {
                case 'text': {
                    let answer = this.oresponse ? this.oresponse.find((answer) => answer.id === subQId) : null
                    if(answer && answer.answer && 'id' in answer.answer[0]) return answer.answer[0].id
                    else return false
                }
                case 'date': {
                    let answer = this.oresponse ? this.oresponse.find((answer) => answer.id === subQId) : null
                    if(answer && answer.answer && 'id' in answer.answer[0]) return answer.answer[0].id
                    else return false
                }
            }
        },
        pickerOptions(bool) {
            return bool ? {
                    disabledDate(date) {
                        return date > Date.now();
                }
            } : {}
        }
    },

    computed: {
        checkIfSaveEligible() {
            return this.updateResponse && this.updateResponse.every((subQuest) => {
                return subQuest.subQustEnblSave
            })
        },
    },

    components: {
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';
.multi-question-edit {
  width: 100%;
  height: 400px;
  overflow-y: scroll;
  scrollbar-color: rebeccapurple green;
  scrollbar-width: thin;
  padding-inline-start: 20px;
}
ol.multi-question-edit li {
  border-bottom: 1px solid #EEEEEE;
  margin-top: 20px;
}
ol.multi-question-edit li:first-child {
  margin-top: 0;
}
ol.multi-question-edit li:last-child {
  border-bottom: 0;
}
.remove-mand-cont {
    height: 30px;
    padding: 5px 0;

    .remove-response {
        display: inline-block;
        margin: 5px 0;
        cursor: pointer;

        span {
            position: unset
        }
    }
}
.sub-quest {
    margin: 5px 0;
    padding: 5px;
}

div.select-sub-quest-cont {
    label.el-radio-button {
        margin: 5px;

        ::v-deep span.el-radio-button__inner {
            border-radius: 25px;
            background-color: #F8F8F8;
            border: 1px solid #EEEEEE;
            box-sizing: border-box;
            color: #666666;
            font-size: 12px;
            box-shadow: none;
            white-space: break-spaces;
            text-align: left;
            word-break: break-word;
        }

        &.selected{
            ::v-deep .el-radio-button__inner {
                border-radius: 25px;
                background-color: #EDF8DF;
                border: 1px solid #709F34;
                box-sizing: border-box;
                color: #709F34;
                font-size: 12px;
                box-shadow: none;
                white-space: break-spaces;
                text-align: left;
                word-break: break-word;
            }
        }

        &:focus:not(.is-focus):not(:active):not(.is-disabled) {
            box-shadow: none;
        }
    }
    .add-button-container {
        border: none;
        padding: 0px;

        &:hover {
            box-shadow: none;
            background-color: transparent;
        }

        ::v-deep svg {
            height: 30px;
            width: 30px;
            position: relative;
            top: 10px;
        }
    }
    .other-added-option-container {
        margin: 0px 5px;

        .other-added-option {
            margin: 5px;
            padding: 12px 20px;
            border-radius: 25px;
            background-color: #F8F8F8;
            border: 1px solid #EEEEEE;
            box-sizing: border-box;
            color: #666666;
            font-size: 12px;
            box-shadow: none;
            display: inline-block;
        }

        .otherSelectedOption {
            background-color: #EDF8DF;
            border: 1px solid #709F34;
            color: #709F34;
        }
    }
    .other-input-container {
        position: relative;
        top: 5px;
        margin-bottom: 8px;

        .other-input-field {
            ::v-deep input.el-input__inner {
                border-radius: 25px;
                font-size: 12px;
                background-color: #F8F8F8;
            }
        }
    }
}

div.date-sub-quest-cont {
    .el-date-editor.el-input {
        margin-left: 10px;
    }
}

div.scroller-sub-quest-cont {
    div.el-radio-group {
        label.el-radio-button {
            margin: 0 5px;

            ::v-deep span.el-radio-button__inner {
                border-radius: 25px;
                background-color: #F8F8F8;
                border: 1px solid #EEEEEE;
                box-sizing: border-box;
                color: #666666;
                font-size: 12px;
                box-shadow: none;
            }

            &.selected{
                ::v-deep .el-radio-button__inner {
                    border-radius: 25px;
                    background-color: #EDF8DF;
                    border: 1px solid #709F34;
                    box-sizing: border-box;
                    color: #709F34;
                    font-size: 12px;
                    box-shadow: none;
                }
            }

            &:focus:not(.is-focus):not(:active):not(.is-disabled) {
                box-shadow: none;
            }
        }
    }
}

div.text-sub-quest-cont {
    .multi-question-edit {
        // margin-block-start: 20px;
        padding-inline-start: 20px;
    }
    .sub-question{
        margin-top: 15px;
        margin-bottom: 5px;
    }
    .el-input {
        margin: 0 10px;
        max-width: 620px;
        min-width: 620px;
        border: 1px solid #EEEEEE;

        ::v-deep input {
            color: #709F34;
            background-color: #F8F8F8;
        }
    }
}

div.unit-sub-quest-cont {
        // display: flex;
        margin: 0px 10px;

        .input-num {
            width: 150px;
            div {
                width: 100%;
            }
        }
        .input-sel{
            width: 250px;
            div {
                width: 100%;
            }
        }

        ::v-deep .error-message {
            color: red;
            font-size: 14px;
        }

        ::v-deep .el-select.el-select--small {
            width: 100%;
        }

    .inl-fl {
        display: inline-flex;
        flex-direction: column;

        &:first-child {
            margin-right: 5px;
        }
        &:nth-child(2) {
            margin-left: 5px;
        }
    }
}
</style>
